'use strict';
ui.loadTemplateFile('login.html');

class LoginDialog extends Dialog {
  _element: any;
  _titleBar: any;
  _username: any;
  _password: any;
  _remember: any;

  constructor() {
    super('login.html');

    this._username = ui.textbox(this, '.username');
    this._password = ui.textbox(this, '.password');
    this._remember = ui.checkbox(this, '.remember');

    let username = localStorage.getItem('login_user');
    if (username) {
      this._username.text(username);
      this._remember.checked(true);
    }

    this._username.on('returnpressed', this._login.bind(this));
    this._password.on('returnpressed', this._login.bind(this));
    ui.button(this, '.submit').on('clicked', this._login.bind(this));
    ui.button(this, '.register').on('clicked', this._register.bind(this));

    this.center();
  }

  _login() {
    const username = this._username.text();
    const password = this._password.text();

    if (this._remember.checked()) {
      localStorage.setItem('login_user', username);
    }

    this.emit('done', username, password);
    this.close();
  }

  _register() {
    this.hide();
    const dialog = ui.registerDialog();
    dialog.on('done', (username: any) => {
      this._username.text(username);
      this._password.text('');
      this.show();
    });
    dialog.on('cancel', () => this.show());
  }
}

ui.LoginDialog = LoginDialog;
ui.loginDialog = () => {
  return new ui.LoginDialog();
};
